import React from 'react'
import PropTypes from 'prop-types'
import { Grid as SemanticGrid } from 'semantic-ui-react'
import styled from 'styled-components'

const Grid = styled(
  ({
    gutter,
    children,
    ...props,
  }) => {
    return (
      <SemanticGrid {...props}>
        {children}
      </SemanticGrid>
    )
  }
)`
  &.ui.grid.grid {
    margin: -${({ gutter }) => gutter || '0.25'}rem;
    
    > .column {
      padding: ${({ gutter }) => gutter || '0.25'}rem;
    }
  }
`

Grid.propTypes = {}
Grid.defaultProps = {}
Grid.Column = SemanticGrid.Column
Grid.Row = SemanticGrid.Row

export default Grid



// WEBPACK FOOTER //
// ./src/components/grids/Grid.js